export const redirect = history => (url, openInNewWindow = false) => {
  if (history && !url.includes('http')) {
    history.replace(url);

    return;
  }

  openInNewWindow ? window.open(url) : window.open(url, '_self');
};

export const objectToQueryString = object => {
  if (Object.values(object).every(value => !value)) {
    return '';
  }

  return Object.keys(object)
    .filter(key => {
      const value = object[key];

      return !Array.isArray(value) ? ![undefined, null, ''].includes(value) : value.length > 0;
    })
    .map(key => {
      const value = object[key];

      return Array.isArray(value) ? `${key}[]=${value}` : `${key}=${value}`;
    })
    .join('&');
};

export const getOfferPageUrl = ({
  city,
  offerId,
  withMapOpened,
  searchId = '',
  filters = {},
  isResidence = false,
  propertyId = null,
  withoutAppUrl = false,
  withCalendarOpened = false,
  language
}) => {
  const query = objectToQueryString({
    ...filters,
    ['open-map']: withMapOpened ? 'yes' : undefined,
    ['open-calendar']: withCalendarOpened ? 'yes' : undefined
  });
  const accommodationOrResidences = isResidence && propertyId ? 'residences' : 'accommodation';
  const id = isResidence && propertyId ? propertyId : offerId;
  const locale = !language || language === 'en' ? '' : `${language}/`;
  const queryPath = query ? `?${query}` : '';
  const searchIdPath = searchId ? `#search-id=${searchId}` : '';
  const cityPath = Array.isArray(city) ? city[0] : city;

  return withoutAppUrl
    ? `${locale}${accommodationOrResidences}/${cityPath}/${id}${queryPath}${searchIdPath}`
    : `${process.env.APP_URL}${locale}${accommodationOrResidences}/${cityPath}/${id}${queryPath}${searchIdPath}`;
};

const formatMoveInOrMoveOut = dateString => {
  if (!dateString) {
    return null;
  }

  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date
    .getDate()
    .toString()
    .padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getCheckoutPage = ({ offerId, moveIn, moveOut, guests, optionId, source = null }) => {
  const query = objectToQueryString({
    ['move-in']: formatMoveInOrMoveOut(moveIn),
    ['move-out']: formatMoveInOrMoveOut(moveOut),
    ['guests']: guests,
    ['option-id']: optionId,
    ['source']: source || 'uniplaces'
  });

  return `${process.env.APP_URL}booking-request/${offerId}?${query}`;
};

export const getSearchPage = ({ cityCode, isResidences, language }) => {
  const languageRoute = language === 'en' ? '' : `${language}/`;
  const searchType = isResidences ? 'residences' : 'accommodation';
  const [, city] = cityCode.split('-');

  return `${process.env.APP_URL}${languageRoute}${searchType}/${city}`;
};

export const getHomepageByLocale = (pathname, locale) => {
  if (pathname.includes('/residences')) {
    return locale === 'en' ? '/residences' : `/${locale}/residences`;
  }

  return locale === 'en' ? '/' : `/${locale}`;
};

export const getDashboardBookingsPage = language => {
  const languageRoute = language === 'en' ? '' : `${language}/`;

  return `${process.env.APP_URL}${languageRoute}dashboard/bookings`;
};

export const redirectToOfferPage = ({
  offerId,
  city,
  searchId,
  withMapOpened = false,
  openInNewWindow = false,
  filters,
  isResidence = false,
  propertyId = null,
  language
}) => {
  return redirect()(
    getOfferPageUrl({ offerId, city, withMapOpened, searchId, filters, isResidence, propertyId, language }),
    openInNewWindow
  );
};

export const redirectToCheckout = (offerId, fields) => redirect()(getCheckoutPage({ offerId, ...fields }));
